export default {
  CREATE_TICKET: 'CREATE_TICKET',
  GET_BIKE_COMPONENT_DATA: 'GET_BIKE_COMPONENT_DATA',
}
